import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function Success({
  color = 'white',
  fill = 'icon.greenCheck',
  strokeWidth = '1.4',
  ...props
}) {
  return (
    <IconBase width='16' height='17' viewBox='0 0 16 17' {...props}>
      <Circle cx='8' cy='8.40625' r='8' fill={fill} />
      <Path
        strokeWidth={strokeWidth}
        d='M11.9975 6.64062L6.99319 11.0056L4.40625 8.5505'
        fill='transparent !important'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Success.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
  fill: PropTypes.string,
}

export default Success
